import { Card } from "@cmp-src/data-display/Card/Card";
import { ReservationCardItem } from "@/features/reservation/components/ReservationCard/ReservationCardItem";
import { getReserveCardKey } from "@/features/reserve/utils/utils-reserve";
import { ISchedule } from "@gettactic/api";
import { useSortedSchedules } from "@gettactic/hooks";
import React from "react";

type ReservationCardListProps = {
  listType: "admin-pending" | "me-pending" | "me-confirmed" | "admin-all";
  schedules: ISchedule[] | null;
  embedded: boolean;
  setOpenReservationsPanel?: React.Dispatch<React.SetStateAction<boolean>>;
  onShowingAnotherModal?: (showing: boolean) => void;
};

export const ReservationCardList = ({
  schedules: unsortedSchedules,
  listType,
  embedded,
  setOpenReservationsPanel,
  onShowingAnotherModal
}: ReservationCardListProps) => {
  const schedules = useSortedSchedules(unsortedSchedules);
  return (
    <>
      {listType === "me-confirmed" && schedules && schedules.length ? (
        <Card
          className="mt-4 mb-2 mr-2"
          contentProps={{ className: "flex content-center justify-between" }}
        >
          <div className="flex items-center">
            <div className="inline-flex items-center">
              <img
                src="https://res.cloudinary.com/tactic/image/upload/q_auto,f_auto,c_scale,w_115/v1612126939/tactic_web/Dashboard/desk_reserved_ynlfkh.svg"
                alt="Computer with app on screen"
                className="w-28"
              />
            </div>
            <div className="ml-6 flex flex-col">
              <p className="mb-0 font-bold text-secondary-foreground">
                Office Space Reserved
              </p>
            </div>
          </div>
        </Card>
      ) : null}
      {(listType === "me-pending" || listType === "admin-pending") &&
      schedules &&
      schedules.length ? (
        <Card
          className="mt-4 mb-2 mr-2"
          contentProps={{ className: "flex content-center justify-between" }}
        >
          <div className="flex items-center">
            <div className="inline-flex items-center">
              <img
                src="https://res.cloudinary.com/tactic/image/upload/q_auto,f_auto,c_scale,w_115/v1612127352/tactic_web/Dashboard/no_desk_reserved_ya5oyl.svg"
                alt="Computer turned off"
                className="w-28"
              />
            </div>
            <div className="ml-6 flex flex-col">
              <p className="mb-0 font-bold text-secondary-foreground">
                Pending Reservation
              </p>
            </div>
          </div>
        </Card>
      ) : null}
      {schedules &&
        schedules.map((schedule) => (
          <ReservationCardItem
            schedule={schedule}
            key={getReserveCardKey(schedule)}
            embedded={embedded}
            setOpenReservationsPanel={setOpenReservationsPanel}
            onShowingAnotherModal={onShowingAnotherModal}
          />
        ))}
    </>
  );
};
